// this is an autogenerated file from DesignSystem/AppsLauncherProperties/Content/ActiveStep/Http/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_AppsLauncherProperties_Content_ActiveStep_Http(
  $id: String!
  $location_id: uuid!
  $resource_id: uuid
  $local: jsonb
  $property_key: String!
) {
  apps_launchers_property_http_values(
    id: $id
    location_id: $location_id
    resource_id: $resource_id
    local: $local
    property_key: $property_key
  ) {
    id
    text: value
  }
}

`